/**
 * Static tag badge - display-only chip matching StaticTagsPickerSection styling.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { cn } from '@/lib/utils';

export interface StaticTagBadgeProps {
  name: string;
  color: string;
  className?: string;
}

export const StaticTagBadge: FC<StaticTagBadgeProps> = ({
  name,
  color,
  className,
}) => (
  <span
    className={cn('inline-flex items-center rounded-md border border-transparent px-2 py-0.5 text-xs font-medium text-white', className)}
    style={{ backgroundColor: color || '#6b7280' }}
  >
    {name}
  </span>
);
